import {
  ActionType,
  DeleteStressCheckData,
  IDeleteStressCheckResponse,
} from "models/stressCheck/deleteStressCheck";

export const deleteStressCheckAction = (payload: DeleteStressCheckData) => {
  return {
    type: ActionType.DELETE_STRESS_CHECK,
    payload,
  };
};

export const handleErrorAction = (payload: string) => {
  return {
    type: ActionType.DELETE_STRESS_CHECK_ERROR,
    payload,
  };
};

export const handleSuccesAction = (payload: IDeleteStressCheckResponse) => {
  return {
    type: ActionType.DELETE_STRESS_CHECK_SUCCESS,
    payload,
  };
};

export const handleResetDataAction = () => {
  return {
    type: ActionType.RESET_DELETE_STRESS_CHECK,
  };
};
